import { useEffect } from 'react';
import { LatestRef, Stage } from './types';

const stageToPath = (stage: Stage) => {
  switch (stage) {
    case 'EDIT':
    case 'QUOTING':
      return '/edit';
    case 'REVIEW':
      return '/review';
    case 'PROCESSING':
      return '/submitting';
    case 'CONFIRMED':
      return '/confirmed';
    default:
      return '';
  }
};

export const useSyncUrlWithState = (ref: LatestRef) => {
  useEffect(() => {
    const { state, booking, navigateTo } = ref.current;
    const pathSuffix = stageToPath(state.stage);
    navigateTo.changeDates('replace', booking.id, pathSuffix);
  }, [ref, ref.current.state.stage, ref.current.booking.id]);
};
